import { useState, useEffect } from "react";
import { verifyUserEmail } from "@/services/api/UserRepository";
import Spinner from "@/components/ui/Spinner/Spinner";
import { useAuthStore } from "@/zustand/authStore";
import OpticksMessage from "@/components/ui/OpticksMessage/OpticksMessage";
import OpticksLogo from "@/components/ui/OpticksLogos/OpticksLogo";

const EmailVerification = () => {
  const [requestInProgress, setRequestInProgress] = useState(false);
  const [boxMessage, setBoxMessage] = useState<string | null>(null);

  useEffect(() => {
    if (!requestInProgress) {
      const params = new URLSearchParams(location.search);
      setRequestInProgress(true);
      verifyUserEmail(params.get("email"), params.get("hash"))
        .then(() => {
          setRequestInProgress(false);
          useAuthStore.getState().setLogin({ hash: params.get("hash") as string });
          setBoxMessage("");
        })
        .catch(() => {
          setRequestInProgress(false);
          setBoxMessage(
            "There was an error trying to verify your account. Try again later."
          );
        });
    }
  }, []);

  return (
    <>
      <OpticksLogo />
      <h2>Email verification</h2>
      <p>Wait a few seconds, you will be redirected.</p>
      {requestInProgress && <Spinner size={50} />}
      {boxMessage && <OpticksMessage type="error">{boxMessage}</OpticksMessage>}
    </>
  );
};

export default EmailVerification;
